import { createColumnHelper } from '@tanstack/react-table';
import {
    PosMicrosIntegrationMicrosOutlet,
    PosMicrosIntegrationTransmissionProtocol,
} from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { FieldNames } from '../fieldNames';
import { useAccountingCategoriesOptions } from '../../hooks/useAccountingCategoriesOptions';
import { MicrosOutletTableDialogActions } from './MicrosOutletTableDialogActions';

const columnHelper = createColumnHelper<PosMicrosIntegrationMicrosOutlet>();

export const useMicrosOutletsColumns = (protocol: PosMicrosIntegrationTransmissionProtocol) => {
    const { accountingCategoriesById } = useAccountingCategoriesOptions();
    const getAccountingCategoryNameValue = (id?: string) => (id && accountingCategoriesById?.[id]?.name) || '';

    return [
        columnHelper.accessor(FieldNames.menuNumber, { header: () => lt('MenuNumber') }),
        columnHelper.accessor(FieldNames.name, { header: () => lt('Name') }),
        /** columnHelper.accessor(FieldNames.netSaleAccountingCategories, {
            header: () => (
                <>
                    {lt('NetSaleAccountingCategory')}
                    <span>{' 1'}</span>
                </>
            ),
            cell: (props) => {
                const list = props.getValue(). ?? [];
                return props.getValue() getAccountingCategoryNameValue(props.getValue()?.categoryId)
            },
        }), */
        columnHelper.accessor(FieldNames.tipsAccountingCategory, {
            header: () => lt('TipsAccountingCategory'),
            cell: (props) => getAccountingCategoryNameValue(props.getValue()?.id),
        }),
        columnHelper.accessor(FieldNames.serviceChargeAccountingCategory, {
            header: () => lt('ServiceChargeAccountingCategory'),
            cell: (props) => getAccountingCategoryNameValue(props.getValue()?.id),
        }),
        columnHelper.display({
            id: 'actions',
            meta: { width: 100, align: 'end' },
            cell: (props) => (
                <MicrosOutletTableDialogActions
                    microsOutlet={props.row.original}
                    rowIndex={props.row.index}
                    protocol={protocol}
                />
            ),
        }),
    ];
};
